module.exports = __webpack_public_path__ + "img/shanhu2.94910a2e.png";